/**
 * Survey QR link for customers.
 * On laptop (localhost), uses auto-detected LAN IP so phone scans work.
 * Override with VITE_SURVEY_FRONTEND_URL in packages/staff/.env if needed.
 */

function surveyFrontendBase() {
  const fromEnv = import.meta.env.VITE_SURVEY_FRONTEND_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim()) {
    return fromEnv.trim().replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:5174';
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Injected at dev-server start by packages/staff/vite.config.js
    const lanIp = typeof __DEV_LAN_IP__ !== 'undefined' ? __DEV_LAN_IP__ : null;
    if (lanIp) {
      return `http://${lanIp}:5174`;
    }
    return 'http://localhost:5174';
  }

  return `http://${hostname}:5174`;
}

export function buildStaffSurveyQrUrl(staffCode) {
  if (!staffCode) return '';
  return `${surveyFrontendBase()}/?ref=${encodeURIComponent(staffCode)}`;
}

export function getSurveyFrontendBase() {
  return surveyFrontendBase();
}
